document.addEventListener('DOMContentLoaded', function () {
  // Query DOM elements

  const sliderContainer = document.querySelector('.product-3-slider');
  const sliderInfoContainer = document.querySelector('.slider-counter'); // Info container
  const sliderItems = sliderContainer ? sliderContainer.querySelectorAll('.slide-item') : null;
  const sliderNextButton = document.querySelector('.controls-next');
  const prevButton = document.querySelector('.controls-prev');

  class Carousel {
    constructor(container, items, infoContainer) {
      this.carouselContainer = container;
      this.carouselArray = [...items];
      this.infoContainer = infoContainer;
      this.currentDirection = ''; // To keep track of the direction
      this.initSlideClasses(); // Initialize slide number classes
      this.setControls();
      this.updateSlider(); // Initialize the gallery
    }

    initSlideClasses() {
      this.carouselArray.forEach((el, i) => {
        if (i < 3) {
          el.classList.add(`slide-item-${i + 1}`);
        }
      });
    }

    updateSlider() {
      this.carouselArray.forEach((el, i) => {
        el.classList.remove('slide-item-1', 'slide-item-2', 'slide-item-3', 'active');
        if (i < 3) {
          el.classList.add(`slide-item-${i + 1}`);
        }
        if (i === 1) {
          // Add active class to the second gallery item
          el.classList.add('active');
        }
      });
      this.updateSliderInfo(); // Update the current slide info
    }

    updateSliderInfo() {
      const totalSlides = this.carouselArray.length;
      const activeSlideIndex =
        Array.from(this.carouselContainer.querySelectorAll('.slide-item')).findIndex((item) =>
          item.classList.contains('active')
        ) + 1;
      this.infoContainer.textContent = `${activeSlideIndex} of ${totalSlides}`;
    }

    setCurrentState(direction) {
      this.carouselContainer.classList.remove('next', 'prev');

      if (direction === prevButton) {
        this.carouselArray.unshift(this.carouselArray.pop());
        this.currentDirection = 'prev';
        this.carouselContainer.classList.add('prev');
      } else {
        this.carouselArray.push(this.carouselArray.shift());
        this.currentDirection = 'next';
        this.carouselContainer.classList.add('next');
      }

      this.updateSlider();
    }

    setControls() {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.setCurrentState(prevButton);
      });

      sliderNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.setCurrentState(sliderNextButton);
      });
    }
  }

  if (sliderItems) {
    const product3slider = new Carousel(sliderContainer, sliderItems, sliderInfoContainer);
  } // product3slider.setControls();
  // product3slider.updateSlider();
});
